import { useDialogStore } from 'src/store/dialog/dialogStore';
import { Slide } from '@mui/material';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';
export const BaseDialog: React.FC = () => {
  const isDialogOpen = useDialogStore((state) => state.isDialogOpen);
  const closeDialog = useDialogStore((state) => state.closeDialog);
  const dialogContent = useDialogStore((state) => state.dialogContent);
  const maxWidth = useDialogStore((state) => state.maxWidth);

  return (
    <Dialog
      open={isDialogOpen}
      onClose={() => {
        closeDialog();
      }}
      maxWidth={maxWidth ?? 'sm'}
      fullWidth
      TransitionComponent={Transition}
    >
      <Box p={2}>{dialogContent}</Box>
    </Dialog>
  );
};
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<unknown> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction='down' ref={ref} {...props} timeout={300} />;
});
